import { ApolloClient, InMemoryCache } from '@apollo/client';
import { authLink, httpLink } from './links';

export const client = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  link: authLink.concat(httpLink),
});

export * from './gql';
